<div *ngIf="!starting">
  <style>
      li {
          padding-bottom: 15px;
      }
  </style>
  <h3 style="margin-top:0;">Welcome to the Guam EPA Online Permit Application Portal!</h3>
  <h4>Please select your permit type from the list below.</h4>
  <ul>
    <li style="list-style-type: none;">
      <h3><i class="fa fa-bolt"></i> Standby Generator Permit</h3>
      All commercial standby generators operating on Guam and emitting more than 2 tons of combined air pollutants
      require an operating permit from Guam EPA. Our online application system will assist you with calculations and
      determine whether you need a permit.
      <br/><br/>
      <ul>
        <li><a style="cursor: pointer; text-decoration: none; color: unset" routerLink="/start/standby"><b>New or
          renewal application</b></a><br/>
          If you are applying for a standby generator permit for the first time, or if you are renewing an existing
          permit, <a style="cursor: pointer;" href="/start/standby">click here</a>. For renewals, you will need
          your current permit number.
        </li>
        <li><a style="cursor: pointer;" (click)="updateApplication('standby')"><b>Update permit application</b></a><br/>
          If you have started an online permit and need to update your application (to update information, fix a
          mistake, or to make a correction requested by Guam EPA),
          <a style="cursor: pointer;" (click)="updateApplication('standby')">click here</a>. You will need your
          application number and
          one of the email addresses provided in your application contacts.
        </li>
        <li><a style="cursor: pointer; text-decoration: none; color: unset" routerLink="/start/standbyannualreport">
          <b>Submit annual emissions information</b></a><br/>
          All permittees are required to annually provide Guam EPA with each unit’s engine hours as of December 31 and
          pay an annual emissions fee. The fee is due by February 28. <a style="cursor: pointer;"
                                                                         routerLink="/start/standbyannualreport">Click
            here</a> to enter engine hours for your
          generator(s) and determine your annual emissions fee.
        </li>
        <li><a routerLink="/help/standby/faq"><b>Frequently Asked Questions</b></a><br/>
          Click here for a list of frequently asked questions (FAQ).
        </li>
        <!--        <li><a><b>Instruction Video</b></a><br/>-->
        <!--          Please watch the video below for an overview of the online standby generator permit application.-->
        <!--          <br/>Coming Soon!-->
        <!--        </li>-->
        <li><b>For more information</b><br/>
          Contact the Guam EPA Air Pollution Control Program at <a target="_blank"
                                                                   href="mailto:air.permits@epa.guam.gov">air.permits&#64;epa.guam.gov</a>
          or call 671-300-4751.
        </li>
      </ul>
    </li>
  </ul>
  <!-- hide unless noa in params -->
  @if (showNOA) {
    <ul>
      <li style="list-style-type: none;">
        <h3><i class="fa fa-bolt"></i> Pesticides Notice of Arrival</h3>
        Need some text for this section.
        <br/><br/>
        <ul>
          <li><a style="cursor: pointer;" routerLink="/start/pesticides_noa"><b>Submit new notice of
            arrival</b></a><br/>

          </li>
          <li><a style="cursor: pointer;" (click)="updateApplication('pesticides_noa')"><b>Update permit application</b></a>
          </li>
        </ul>
      </li>
    </ul>
  }
  <!-- hide unless onestop in params -->

  <ul *ngIf="false">
    <li style="list-style-type: none;">
      <h3><i class="fa fa-bolt"></i> One Stop Permit</h3>
      Something insightful
      <br/><br/>
      <ul>
        <li><a style="cursor: pointer;" href="/start/onestop"><b>Submit new one stop permit</b></a><br/>

        </li>
        <li><a style="cursor: pointer;" (click)="updateApplication('pesticides_noa')"><b>Update one stop permit</b></a>
        </li>
      </ul>
    </li>
  </ul>
  <!--<button href="/start/standby" class="btn btn-default" style="margin-bottom: 5px;">Start Standby
       Generators<br/>Permit Application
   </button>
   <button (click)="updateApplication('standby')" class="btn btn-default" style="margin-bottom: 5px;">Update Standby
       Generators<br/>Permit Application
   </button>
   <button (click)="login('standbyannualreport', 'Standby Generator Permit Number')" class="btn btn-default" style="margin-bottom: 5px;">
       Standby Generator <br/>Annual Reporting
   </button>-->
  <!--  <a style="cursor: pointer;" (click)="updateApplication('pesticides_noa')">click here</a>-->
</div>
